import { cn } from '~/utils/cn'

import { Icon } from '~/components/icon'

import { infoStyles } from './product-header.styles'

type BaseProps = {
  context?: 'default' | 'default-icon'
  brand?: string
  measurement: string
}

type ProductProps = BaseProps & {
  type: 'product'
  manufacturer: string
  activeIngredient?: never
}

type MedicineProps = BaseProps & {
  type: 'medicine'
  activeIngredient: string
  manufacturer?: never
}

type ProductHeaderInfoProps = ProductProps | MedicineProps

export function ProductHeaderInfo({
  type,
  context = 'default-icon',
  brand,
  measurement,
  manufacturer,
  activeIngredient,
}: ProductHeaderInfoProps) {
  const withIcon = context === 'default-icon'

  const items = [
    {
      value: brand,
      show: !!brand,
    },
    {
      value: measurement,
      show: true,
    },
    {
      value: type === 'medicine' ? activeIngredient : manufacturer,
      show: true,
    },
  ]

  return (
    <div
      className={cn(
        infoStyles({
          className:
            type === 'product'
              ? 'mt-[var(--spacing-stack-onepulse)]'
              : 'mt-[var(--spacing-inline-twopulse)] ',
        })
      )}
    >
      {items.map(
        ({ value, show }, index) =>
          show && (
            <ProductInlineInfo key={index.toString()} enableBullet={!withIcon}>
              {withIcon && <Icon size="tiny" />}
              {value}
            </ProductInlineInfo>
          )
      )}
    </div>
  )
}

interface ProductInlineInfoProps extends React.ComponentProps<'span'> {
  enableBullet?: boolean
}

function ProductInlineInfo({
  children,
  className,
  enableBullet = false,
  ...props
}: ProductInlineInfoProps) {
  return (
    <span
      {...props}
      className={cn(
        'inline-flex w-fit items-center justify-center gap-x-[var(--spacing-stack-onepulse)] whitespace-nowrap',
        'font-normal text-[length:var(--font-size-threeandhalfpulse)] text-[var(--color-text-neutral-alternative)] leading-[var(--line-height-small)]',
        enableBullet && "before:content-['•']",
        className
      )}
    >
      {children}
    </span>
  )
}
